import { TimestampStateObject , TimestampFetchLabels} from "../types/contexts/globalContext";
import { logAdminExternal } from '../utils/logging';


export interface UpdateFetchTimestamps {
    type: 'update fetch timestamps',
    payload: {
        labels: TimestampFetchLabels[]
    },
}

export type TimestampsReducerAction = UpdateFetchTimestamps;



export function timeStampReducer(initialState: TimestampStateObject, action: TimestampsReducerAction): TimestampStateObject {
    const returnState = { ...initialState };
    const currentTimestamp = new Date().toUTCString()
    switch (action.type) {
        case "update fetch timestamps": {
            action.payload.labels.forEach(thisLabel => {
                returnState.fetch[thisLabel] = currentTimestamp;
            })
            break;
        }
        default:
            logAdminExternal({
                status: "userDetailsReducer returning default value"
            })
            return initialState

    }
    localStorage.setItem("timestamps", JSON.stringify(returnState));
    return returnState
}